import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './Services.css'; // Custom styles
import API_URL from '../../api/ExamCalendarApi';


const Services = () => {
  const [services, setServices] = useState([]);
  const [formData, setFormData] = useState({
    title: '',
    logo: null
  });
  const [editServiceId, setEditServiceId] = useState(null);
  const [errorMessage, setErrorMessage] = useState('');

  // Fetch all services
  const fetchServices = async () => {
    try {
      const response = await axios.get(`${API_URL}/homepage/all-services`);
      setServices(response.data.services);
    } catch (error) {
      console.error('Error fetching services:', error);
      setErrorMessage('Failed to fetch services.');
    }
  };

  useEffect(() => {
    fetchServices();
  }, []);

  // Handle form change
  const handleChange = (e) => {
    const { name, value, files } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: files ? files[0] : value
    }));
  };

  // Handle form submit
  const handleSubmit = async (e) => {
    e.preventDefault();

    const formPayload = new FormData();
    formPayload.append('title', formData.title);
    if (formData.logo) {
      formPayload.append('logo', formData.logo);
    }

    try {
      if (editServiceId) {
        // Update service
        await axios.put(`${API_URL}/homepage/update-service/${editServiceId}`, formPayload);
        setEditServiceId(null);
      } else {
        // Add service
        await axios.post(`${API_URL}/homepage/add-service`, formPayload);
      }
      setFormData({ title: '', logo: null });
      fetchServices();
    } catch (error) {
      console.error('Error saving service:', error);
      setErrorMessage('Failed to save service.');
    }
  };

  // Handle delete service
  const handleDelete = async (id) => {
    if (window.confirm('Are you sure you want to delete this service?')) {
      try {
        await axios.delete(`${API_URL}/homepage/delete-service/${id}`);
        fetchServices();
      } catch (error) {
        console.error('Error deleting service:', error);
        setErrorMessage('Failed to delete service.');
      }
    }
  };

  // Handle edit service
  const handleEdit = (service) => {
    setEditServiceId(service._id);
    setFormData({ title: service.title, logo: null });
  };

  return (
    <div className="admin-services-container">
      <h2 className="admin-services-title">Service Management</h2>

      {errorMessage && <div className="admin-services-error-message">{errorMessage}</div>}

      <form onSubmit={handleSubmit} className="admin-services-form">
        <div className="admin-services-form-group">
          <label>Service Title</label>
          <input
            type="text"
            name="title"
            className="admin-services-form-control"
            value={formData.title}
            onChange={handleChange}
            required
          />
        </div>

        <div className="admin-services-form-group">
          <label>Service Logo</label>
          <input
            type="file"
            name="logo"
            className="admin-services-form-control"
            onChange={handleChange}
          />
        </div>

        <button type="submit" className="admin-services-btn admin-services-btn-primary">
          {editServiceId ? 'Update Service' : 'Add Service'}
        </button>
      </form>

      <h4 className="admin-services-all-title">All Services</h4>
      <div className="admin-services-table-wrapper">
      <table className="admin-services-table">
        <thead>
          <tr>
            <th>Title</th>
            <th>Logo</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {services.map((service) => (
            <tr key={service._id}>
              <td>{service.title}</td>
              <td>
                {service.logo && (
                  <img
                    src={service.logo}
                    alt={service.title}
                    className="admin-services-img-thumbnail"
                    width="100"
                  />
                )}
              </td>
              <td>
                <button
                  className="admin-services-btn admin-services-btn-warning"
                  onClick={() => handleEdit(service)}
                >
                  Edit
                </button>
                <button
                  className="admin-services-btn admin-services-btn-danger"
                  onClick={() => handleDelete(service._id)}
                >
                  Delete
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      </div>
    </div>
  );
};

export default Services;
